module.exports = __webpack_public_path__ + "img/check-circle-blue.3c55c329.svg";